import { createSlice } from "@reduxjs/toolkit";
import { FetchMultiUrlData } from "../requests/multiUrl";

const emptyLocation = {
  id: Date.now(),
  countryId: "",
  cityId: "",
  link: "",
  linkValid: false,
};

const emptyNumberOfScans = {
  id: Date.now(),
  scanNumber: 0,
  link: "",
  linkValid: false,
};

const emptyLanguage = {
  id: Date.now(),
  languageId: "",
  link: "",
  linkValid: false,
};

const emptyTime = {
  id: Date.now(),
  timezoneId: "",
  startTime: "",
  endTime: "",
  link: "",
  linkValid: false,
};

const initialState = {
  status: null,
  defaultUrl: "",
  locations: [emptyLocation],
  numberOfScans: [emptyNumberOfScans],
  languages: [emptyLanguage],
  times: [emptyTime],
};

const multiUrl = createSlice({
  name: "multiUrl",
  initialState,
  reducers: {
    resetMultiUrl() {
      return initialState;
    },
    setDefaultUrl(state, { payload }) {
      state.defaultUrl = payload;
    },
    addLocation(state) {
      state.locations.push({ ...emptyLocation, id: Date.now() });
    },
    updateLocationItem(state, { payload }) {
      state.locations = state.locations.map((item) =>
        item.id === payload.id ? { ...item, ...payload } : item
      );
    },
    deleteLocation(state, { payload }) {
      state.locations = state.locations.filter((item) => item.id !== payload);
    },
    addNumberOfScan(state) {
      state.numberOfScans.push({ ...emptyNumberOfScans, id: Date.now() });
    },
    updateNumberOfScanItem(state, { payload }) {
      state.numberOfScans = state.numberOfScans.map((item) =>
        item.id === payload.id ? { ...item, ...payload } : item
      );
    },
    deleteNumberOfScan(state, { payload }) {
      state.numberOfScans = state.numberOfScans.filter(
        (item) => item.id !== payload
      );
    },
    addLanguage(state) {
      state.languages.push({ ...emptyLanguage, id: Date.now() });
    },
    updateLanguageItem(state, { payload }) {
      state.languages = state.languages.map((item) =>
        item.id === payload.id ? { ...item, ...payload } : item
      );
    },
    deleteLanguage(state, { payload }) {
      state.languages = state.languages.filter((item) => item.id !== payload);
    },
    addTime(state) {
      state.times.push({ ...emptyTime, id: Date.now() });
    },
    updateTimeItem(state, { payload }) {
      state.times = state.times.map((item) =>
        item.id === payload.id ? { ...item, ...payload } : item
      );
    },
    deleteTime(state, { payload }) {
      state.times = state.times.filter((item) => item.id !== payload);
    },
  },
  extraReducers: {
    [FetchMultiUrlData.pending]: (state) => {
      state.status = "load";
    },
    [FetchMultiUrlData.rejected]: (state) => {
      state.status = "failed";
    },
    [FetchMultiUrlData.fulfilled]: (state, { payload }) => {
      state.status = "success";
      state.defaultUrl = payload.defaultUrl;
      state.locations = payload.locations.length
        ? payload.locations
        : state.locations;
      state.languages = payload.languages.length
        ? payload.languages
        : state.languages;
      state.numberOfScans = payload.numberOfScans.length
        ? payload.numberOfScans
        : state.numberOfScans;
      state.times = payload.times.length ? payload.times : state.times;
    },
  },
});
export const {
  resetMultiUrl,
  addLocation,
  setDefaultUrl,
  deleteLocation,
  addNumberOfScan,
  updateNumberOfScanItem,
  deleteNumberOfScan,
  updateLocationItem,
  addLanguage,
  updateLanguageItem,
  deleteLanguage,
  addTime,
  updateTimeItem,
  deleteTime,
} = multiUrl.actions;
export default multiUrl.reducer;
